import React from "react";
import "../styles/Projects.css";


const projects = [

  {
    title: "Windows AI Assistant",

    description:
      "A voice-controlled desktop assistant that can open applications, search the web and automate tasks.",

    tech: [
      "Python",
      "AI",
      "Speech Recognition"
    ],

    github:
      "https://github.com/hoomanyyy/Windows-AI-Companion"
  },


{
  title: "Xray V2Ray Panel",

  description:
    "A web-based management panel for managing Xray and V2Ray services with a focus on automation and easier configuration.",

  tech: [
    "React",
    "Node.js",
    "Linux",
    "Networking"
  ],

  github:
    "https://github.com/hoomanyyy/xray-v2ray-panel"
},

  {
    title: "Hand Tracking Mouse",

    description:
      "A computer vision project that allows controlling the mouse using hand gestures.",

    tech: [
      "Python",
      "OpenCV",
      "MediaPipe"
    ],

    github:
      "https://github.com/hoomanyyy/hand-tracking"
  }

];



const Projects = () => {

  return (

    <section className="projects-section">


      <div className="projects-box">


        <h2>
          Featured Projects
        </h2>


        <p className="projects-description">

          Some projects I built while learning and
          exploring new technologies.

        </p>



        <div className="project-grid">


          {projects.map((project) => (

            <div
              className="project-card"
              key={project.title}
            >


              <div className="project-icon">
                💻
              </div>



              <h3>
                {project.title}
              </h3>



              <p>
                {project.description}
              </p>



              <div className="project-tech">

                {project.tech.map((item)=>(
                  <span key={item}>
                    {item}
                  </span>
                ))}

              </div>



              <a
                href={project.github}
                target="_blank"
                rel="noreferrer"
              >
                View on GitHub →
              </a>



            </div>

          ))}


        </div>


      </div>


    </section>

  );

};


export default Projects;